import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { StyledScrollToTop } from "./scroll-to-top.scss";
import DefaultProps from "./default-props";
import { ScrollIcon } from "./scroll-icon";
const DEFAULT_SCROLL_OFFSET_TO_DISPLAY = 100;
const ScrollToTop = ({ scrollOffsetToDisplay = DEFAULT_SCROLL_OFFSET_TO_DISPLAY })=>{
    const [isDisplayed, setIsDisplayed] = useState(false);
    useEffect(()=>{
        const handleScroll = ()=>{
            window.scrollY >= scrollOffsetToDisplay ? setIsDisplayed(true) : setIsDisplayed(false);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const onClick = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ _jsx(StyledScrollToTop, {
        onClick: onClick,
        className: "scroll-to-top",
        isDisplayed: isDisplayed,
        children: /*#__PURE__*/ _jsx(ScrollIcon, {})
    });
};
export default ScrollToTop;
ScrollToTop.defaultProps = DefaultProps;
